import React from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { range } from "../../lib/js_utils/array_utils";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { Icon } from "../../components";
import pluralize from "pluralize";

interface GuestPickerProps {
  value?: number;
  onChange: (value: number) => void;
  limitGuestPicker?: number;
  disabled: boolean;
}

export function GuestPicker(props: GuestPickerProps) {
  const { value, disabled = false, onChange, limitGuestPicker } = props;
  const { fbt } = useI18n();

  const options = limitGuestPicker
    ? range(1, limitGuestPicker).map((n) => ({
        label: `${n} ${fbt(pluralize("Guest", n))}`,
        value: n,
      }))
    : undefined;

  if (!options) {
    return null;
  }

  return (
    <div className="checkout-box-picker-view">
      <Dropdown
        as={ButtonGroup}
        className="checkout-box-picker row"
        id={`guest-picker`}
        size="lg"
        onSelect={(value: any) => onChange(value)}
      >
        <Dropdown.Toggle disabled={disabled}>
          <div className="row">
            <div className="col-10 checkout-box-picker-placeholder">
              <span className="row fw-bold text-uppercase checkout-box-picker-placeholder__label">
                {fbt("Guest")}
              </span>
              <span className="row checkout-box-picker-selected">
                {value ? (
                  `${value} ${value > 1 ? fbt("Guests") : fbt("Guest")}`
                ) : (
                  <span className="fw-lighter checkout-box-picker-selected__placeholder">
                    {fbt("Select number of guests")}
                  </span>
                )}
              </span>
            </div>
            <div className="checkout-box-picker-icon">
              <Icon name="fi-chevron-down" size={24} />
            </div>
          </div>
        </Dropdown.Toggle>
        <DropdownMenu
          popperConfig={{
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  altAxis: true,
                },
              },
            ],
          }}
          style={{ maxHeight: 400, overflowY: "scroll" }}
        >
          <Dropdown.Header className="text">
            <div className="dropdown-header">
              <span className="row fw-bold text-uppercase">
                {fbt("Select number of guests")}
              </span>
            </div>
          </Dropdown.Header>
          {options.map((opt, index) => (
            <>
              <Dropdown.Item
                as="button"
                eventKey={opt.value}
                active={opt.value === Number(value)}
              >
                {opt.label}
              </Dropdown.Item>
              {index !== options.length - 1 && <Dropdown.Divider />}
            </>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
